import useFetch from 'use-http';
import { useForm, Controller, SubmitHandler } from 'react-hook-form';
import layoutClasses from 'components/Layout/styles.module.scss';
import classes from './styles.module.scss';
import classNames from 'classnames';
import { IStore } from 'dto/store.dto';
import File from 'components/UI/File';
import { $user } from 'models/user';
import Textarea from 'components/UI/Textarea';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import Button from 'components/UI/Button';
import { useCallback, useEffect } from 'react';
import { useUnit } from 'effector-react';

const schema = yup.object({
	file: yup.mixed(),
	description: yup.string().required('Поле обязательно к заполнению'),
});

export default function ManagersCommentForm({ store, onClose }: { store?: IStore; onClose: () => void }) {
	const { handleSubmit, watch, control } = useForm<any>({
		defaultValues: { files: [], description: '' },
		resolver: yupResolver(schema),
		mode: 'onChange',
	});
	const user = useUnit($user);
	const { post, loading, error, response } = useFetch();

	const onSubmit: SubmitHandler<any> = useCallback(
		async data => {
			const formData = new FormData();
			formData.append('description', data.description);
			formData.append('storeNumber', store ? store.number : '');
			formData.append('storeTitle', store ? store.title : '');
			formData.append('firstname', user?.given_name ?? '');
			formData.append('secondname', user?.family_name ?? '');
			formData.append('email', user?.email ?? '');

			for (let i = 0; i < data.files.length; i += 1) {
				formData.append('files', data.files[i]);
			}

			await post('/api/tickets/comment', formData);
		},
		[user],
	);

	return (
		<div>
			{response.ok ? (
				<div
					style={{
						textAlign: 'center',
						minHeight: '80px',
						display: 'flex',
						flexDirection: 'column',
						alignItems: 'center',
						justifyContent: 'space-between',
					}}
				>
					<h2>Письмо отправлено</h2>
					<Button
						onClick={onClose}
						style={{ background: 'rgb(83, 195, 92)', marginTop: '16px' }}
						type="submit"
						size="md"
					>
						Ок
					</Button>
				</div>
			) : (
				<>
					<div style={{ textAlign: 'center' }}>
						{error && 'Error!'}
						{loading && 'Загрузка...'}
					</div>
					<form onSubmit={handleSubmit(onSubmit)}>
						<header className={layoutClasses.header}>
							<h1 className={layoutClasses['time-header']}>Комментарий РД/ЗРД</h1>
						</header>
						<div className={layoutClasses.main}>
							<div className={layoutClasses.help}>
								<div className={classNames(layoutClasses['help__form'], classes['form'])}>
									<Controller
										name="description"
										control={control}
										render={({ field, fieldState }) => (
											<Textarea
												onChange={field.onChange}
												onBlur={field.onBlur}
												name={field.name}
												error={fieldState.error}
												label="Краткое описание"
												defaultValue={field.value}
											/>
										)}
									/>
									<Controller
										name="files"
										control={control}
										render={({ field, fieldState }) => (
											<File
												onChange={field.onChange}
												name={field.name}
												labelClass="label__title"
												error={fieldState.error}
												label="Пример фото"
												nowrap
												id="file4manager_comment"
												multiple={true}
											/>
										)}
									/>
								</div>
								<div className={layoutClasses['help__row']}>
									<Button
										disabled={(watch('description')?.length ?? 0) === 0}
										style={{ background: 'rgb(83, 195, 92)' }}
										type="submit"
										size="md"
									>
										Отправить
									</Button>
									<Button onClick={onClose} style={{ background: 'rgb(204, 85, 85)' }} type="submit" size="md">
										Отменить
									</Button>
								</div>
							</div>
						</div>
					</form>
				</>
			)}
		</div>
	);
}
